<div *ngIf="recurringTransactionsState$ | async as state" class="w-full">
  <div *ngIf="state.data?.length && !state.loading && !state.error" class="overflow-x-auto w-full">
    <table mat-table multiTemplateDataRows [dataSource]="state.data">
      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Starting Date</th>
        <td mat-cell *matCellDef="let element" class="!border-b-0 !h-10">
          {{ element.date | date: 'longDate' }}
        </td>
      </ng-container>

      <!-- Type Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let element" class="!border-b-0 !h-10">
          <span class="flex items-center gap-2">
            {{ element.recurrence.type | humanize }} {{ element.type | titlecase }}
          </span>
        </td>
      </ng-container>

      <!-- Category Column -->
      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef>Category</th>
        <td mat-cell *matCellDef="let element" class="!border-b-0 !h-10">
          {{ element.lines[0].category | humanize }}
        </td>
      </ng-container>

      <!-- Description Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let element" class="!border-b-0 !h-10">
          {{ element.lines[0].description }}
        </td>
      </ng-container>

      <!-- Property Column -->
      <ng-container matColumnDef="property">
        <th mat-header-cell *matHeaderCellDef>Property</th>
        <td mat-cell *matCellDef="let element" class="!border-b-0 !h-10">
          {{ element.property.name }}
        </td>
      </ng-container>

      <!-- Total Column -->
      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef>Total</th>
        <td mat-cell *matCellDef="let element" class="!border-b-0 !h-10">
          <span class="font-mono text-right">
            {{ element.currency | currencyCode }}{{ element.lines | transactionTotal }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="upcomingDate">
        <td mat-cell *matCellDef="let element" colspan="6">
          <div
            *ngIf="element.upcoming_dates.length; else noUpcomingDates"
            class="flex flex-wrap gap-2 text-night-lighter">
            <sbnb-icon icon="recurring-financial" [size]="16" class="text-night-lighter"></sbnb-icon>
            Repeats {{ element.recurrence.type }} on {{ element.recurrence | recurrenceSchedule }}. The next occurrence
            is on {{ element.upcoming_dates[0] | date: 'longDate' }}.
          </div>
          <ng-template #noUpcomingDates>
            <div class="text-night-lighter">
              <ng-container [ngSwitch]="element.recurrence.type">
                <ng-container *ngSwitchCase="recurrenceType.EveryBookedNight">
                  Schedule is variable based on booked nights.
                </ng-container>
                <ng-container *ngSwitchCase="recurrenceType.PerReservation">
                  Schedule is variable based on reservations.
                </ng-container>
              </ng-container>
            </div>
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="hover:bg-smoke-lighter cursor-pointer"
        [routerLink]="['./', row.id, 'recurring']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['upcomingDate']" style="height: 36px !important"></tr>
    </table>
  </div>

  <div
    *ngIf="!state.loading && !state.error && state.data.length === 0"
    class="w-full flex mt-12 items-center justify-center">
    <sbnb-no-items
      text="No recurring transactions exist yet."
      [buttons]="buttons"
      (button)="onAddTransaction()"></sbnb-no-items>
  </div>

  <sbnb-loading-spinner *ngIf="state.loading"></sbnb-loading-spinner>

  <div *ngIf="state.error">{{ state.error }}</div>
</div>
